module.exports = __webpack_public_path__ + "img/parcel.cb6f5274.svg";